import React, { useEffect, useState } from 'react';
import Link from 'components/UI/Link';
import Icon from 'components/UI/Icon';
import { isRequestedFrom, useLang } from 'utils/localisation';
import { euroMoneyRegion, germanRegion } from 'define/locale';
import * as styles from './SocialMediaIcon.module.scss';

export default function SocialMediaIcon() {
  const lang = useLang();

  const defaultLinkedInLink =
    lang === 'de'
      ? 'https://www.linkedin.com/company/andersen-europe/'
      : 'https://www.linkedin.com/company/andersen-lab';

  const defaultInstagramLink =
    lang === 'de'
      ? 'https://www.instagram.com/andersen_germany'
      : 'https://www.instagram.com/andersen.global/';

  const [linkedInLink, setLinkedInLink] = useState(defaultLinkedInLink);
  const [instagramLink, setInstagramLink] = useState(defaultInstagramLink);

  useEffect(() => {
    const euWithoutPl = euroMoneyRegion.filter(region => region !== 'pl');

    if (lang === 'en' && isRequestedFrom(euWithoutPl)) {
      setLinkedInLink('https://www.linkedin.com/company/andersen-europe/');
    }

    if (lang === 'en' && isRequestedFrom(germanRegion)) {
      setInstagramLink('https://www.instagram.com/andersen_germany');
    }
  }, [lang]);

  return (
    <>
      <Link href="https://www.facebook.com/AndersenSoftwareDev" className={styles.link}>
        <Icon name="facebook-circle" className={styles.icon} aria-label="Facebook link" />
      </Link>
      <Link href="https://www.xing.com/pages/andersen" className={styles.link}>
        <Icon name="xing-circle" className={styles.icon} aria-label="Xing link" />
      </Link>
      <Link href={linkedInLink} className={styles.link}>
        <Icon name="linkedin-circle" className={styles.icon} aria-label="Linkedin link" />
      </Link>
      <Link href="https://twitter.com/AndersenLabs" className={styles.link}>
        <Icon name="twitter-round" className={styles.icon} aria-label="Twitter link" />
      </Link>
      <Link href={instagramLink} className={styles.link}>
        <Icon name="instagram-circle" className={styles.icon} aria-label="Instagram link" />
      </Link>
      <Link href="https://www.behance.net/andersenlab_design" className={styles.link}>
        <Icon name="behance-circle" className={styles.icon} aria-label="Behance link" />
      </Link>
      <Link href="https://dribbble.com/andersen-design" className={styles.link}>
        <Icon name="dribbble" className={styles.icon} aria-label="Dribbble link" />
      </Link>
      <Link
        href="https://clutch.co/profile/andersen?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=stars#reviews"
        className={styles.link}
      >
        <Icon name="clutch" className={styles.clutchIcon} aria-label="Clutch link" />
      </Link>
    </>
  );
}
